import {LOOKUP_ENUM} from "../../dictionary/core/lookup.enum";
export const ORDER_TYPE = LOOKUP_ENUM.ORDER_TYPE;
